export default "__VITE_ASSET__Dsg7uras__"